<div class="is-relative">
    <isav-tabs isavChangesControlTabs [borders]="true" panelClass="content-type-form">
        <isav-tab title="edit">
            <ng-container *isavTabTitle>Edit</ng-container>
            <isav-people-edit-form
                *isavTabContent
                [value]="data"
                (save)="onSave($event)"
                (wipe)="onWipeData()"
            ></isav-people-edit-form>
        </isav-tab>
        <isav-tab title="credentials">
            <ng-container *isavTabTitle>Credentials</ng-container>
            <isav-people-edit-credentials
                *isavTabContent
                [value]="data"
            ></isav-people-edit-credentials>
        </isav-tab>
        <isav-tab *isavUserHasRole="['ROLE_ADMIN']" title="admin">
            <ng-container *isavTabTitle>Admin</ng-container>
            <isav-people-edit-admin-form
                *isavTabContent
                [value]="data"
            ></isav-people-edit-admin-form>
        </isav-tab>
    </isav-tabs>
    <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
</div>
